import { bunja } from 'bunja';
import { atom } from 'jotai';
import { atomWithQuery, queryClientAtom } from 'jotai-tanstack-query';

import { getCopyTradeMeApi, getCopyTradePortfoliosApi, getCopyTradeSummaryApi } from '@flipster/apis/v1/copy-trade';
import { JotaiStoreScope } from '@flipster/utils/bunja-jotai';

import { authBunja } from '../auth/state';

export const copyTradingBunja = bunja(() => {
  const store = bunja.use(JotaiStoreScope);
  const { isCookieLoggedInAtom } = bunja.use(authBunja);
  const portfoliosBaseAtom = atomWithQuery(() => ({
    queryKey: ['getCopyTradePortfoliosApi'],
    queryFn: getCopyTradePortfoliosApi,
  }));
  const summaryBaseAtom = atomWithQuery(() => ({
    queryKey: ['getCopyTradeSummaryApi'],
    queryFn: getCopyTradeSummaryApi,
  }));
  const myStatusBaseAtom = atomWithQuery((get) => ({
    queryKey: ['getCopyTradeMeApi'],
    queryFn: getCopyTradeMeApi,
    enabled: get(isCookieLoggedInAtom),
    refetchOnMount: 'always',
  }));
  const portfoliosAtom = atom((get) => get(portfoliosBaseAtom).data?.data.portfolios ?? []);
  const topMasterAtom = atom((get) => get(summaryBaseAtom).data?.data.topMaster);
  const isLoadingAtom = atom(
    (get) => get(portfoliosBaseAtom).isLoading || get(summaryBaseAtom).isLoading || get(myStatusBaseAtom).isLoading,
  );
  const myStatusAtom = atom((get) => get(myStatusBaseAtom).data?.data);
  function invalidatePortfolioQueries() {
    const queryClient = store.get(queryClientAtom);
    return Promise.all([
      queryClient.invalidateQueries({ queryKey: ['getCopyTradePortfoliosApi'] }),
      queryClient.invalidateQueries({ queryKey: ['getCopyTradeSummaryApi'] }),
      queryClient.invalidateQueries({ queryKey: ['getCopyTradeMeApi'] }),
      queryClient.invalidateQueries({ queryKey: ['getCopyTradeMyCopiesApi'] }),
      queryClient.invalidateQueries({ queryKey: ['getCopyTradeMyCopyDetailApi'] }),
    ]);
  }
  return {
    isLoadingAtom,
    portfoliosAtom,
    topMasterAtom,
    myStatusAtom,
    isLoggedInAtom: isCookieLoggedInAtom,
    invalidatePortfolioQueries,
  };
});
copyTradingBunja.debugLabel = 'copyTradingBunja';
